import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

const LanguageContext =
  createContext(null);

const STORAGE_KEY =
  'ace-language';

export const LanguageProvider = ({
  children,
}) => {
  const [language, setLanguage] =
    useState(() => {
      const savedLanguage =
        window.localStorage.getItem(
          STORAGE_KEY
        );

      return (
        savedLanguage === 'fr'
          ? 'fr'
          : 'en'
      );
    });

  useEffect(() => {
    window.localStorage.setItem(
      STORAGE_KEY,
      language
    );

    document.documentElement.lang =
      language;
  }, [language]);

  const value =
    useMemo(
      () => ({
        language,
        setLanguage,
      }),
      [language]
    );

  return (
    <LanguageContext.Provider
      value={value}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context =
    useContext(LanguageContext);

  if (!context) {
    throw new Error(
      'useLanguage must be used inside LanguageProvider.'
    );
  }

  return context;
};
